//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const validate = {}
import { iosInput } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import vote from '@/mixins/vote'
import rulePlaceholder from '../mixins/rulePlaceholder'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [vote, rulePlaceholder, downloadImgs],
  data() {
    return {
      currentValue: '',
      inputValue: '',
      rule: {
        custom: {
          radioValue: {
            required: () => '请选择一个选项',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.question.options.forEach((item, index) => {
      item.isShowBlank = false
      if (item.blankVisible) {
        item.name = `inputValue${index}`
        item.value = ''
      }
    })
    // 设置投票， 在 mixins 中
    this.mountedVote()
  },
  mounted() {
    const rule = {
      required: () => '请输入内容',
    }
    this.blankOption.forEach((item) => {
      this.rule.custom[item.name] = rule
    })
    console.log(this.rule)
    this.$validator.localize('zh_CN', this.rule)
    //已答的题挂上答案
    if (this.question.v_answer) {
      //选中选项
      this.currentValue =
        this.question.v_answer.currentValue &&
        this.question.v_answer.currentValue.join('')
      // 其他选项的文字
      const checkedOptions = this.question.v_answer.options
      checkedOptions &&
        checkedOptions.forEach((item) => {
          this.question.options.forEach((o) => {
            if (
              o.blankVisible &&
              item.tenantId == o.tenantId &&
              item.text != o.text
            ) {
              o.value = item.text
            }
          })
        })
    }
    console.log(this.question)
    console.log(this.question.v_answer)
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    // 有输入框的选项
    blankOption() {
      return this.question.options.filter((item) => {
        return item.blankVisible
      })
    },
  },
  watch: {
    async currentValue(n, o) {
      this.question.options.forEach((item) => {
        item.isShowBlank = false
      })
      const param = {
        index: this.index,
        v_answered: !!n,
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      // 判断选择的选项带不带输入框
      let checkedOption = this.blankOption.find((item) => {
        return item.tenantId == n
      })
      // 带input的输入框被选中
      if (checkedOption) {
        this.$set(checkedOption, 'isShowBlank', true)
        // 校验输入框是否必填
        let check = await this.$validator.validateAll({
          [checkedOption.name]: checkedOption.value,
        })
        console.log(check)
        if (check) {
          v_answer = this.getValue(checkedOption.value)
        }
      } else {
        // 不带input框的选项被选中
        this.$validator.errors.clear()
        v_answer = this.getValue()
      }
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')
    },
  },
  methods: {
    validateNumber(option) {
      return (
        option.blankMaxLengthVisible &&
        Number(option.applyNumber || 0) >= Number(option.blankMaxLength || 0)
      )
    },
    formatList(list) {
      let start = list[0]
      let end = list[1]
      return `${start}-${end}`
    },
    onBlur() {
      iosInput()
    },
    getValidateRule(item) {
      var rules = []
      if (item.blankRequired) {
        rules.push('required')
      }
      if (item.blankMaxLength) {
        rules.push(`max:${item.blankMaxLength}`)
      }
      if (item.blankRule !== 'ignore') {
        if (item.blankRule === 'number') {
          rules.push(`number`)
          rules.push(
            `between:${item.blankMinLength || 0},${
              item.blankMaxLength || 99999
            }`
          )
        } else {
          rules.push(`${item.blankRule}`)
        }
      }
      console.log(rules.join('|'))
      return rules.join('|')
    },
    getValue(value) {
      let options = []
      let checkedOption = this.question.options.find((item) => {
        return item.tenantId == this.currentValue
      })
      options.push({
        tenantId: checkedOption.tenantId,
        text: value ? value : '', //checkedOption.text
      })
      return {
        tenantId: this.question.tenantId,
        type: 'activity_time',
        options: options,
        currentValue: [this.currentValue],
      }
    },
    validate() {
      return this.$validator
        .validateAll({
          radioValue: this.currentValue,
        })
        .then((check) => {
          if (check) {
            // 如果有文本框的选项被选中，验证文本框是否填写
            let checkedOption = this.blankOption.find((item) => {
              return item.tenantId == this.currentValue
            })
            if (checkedOption) {
              return this.$validator.validateAll({
                [checkedOption.name]: checkedOption.value,
              })
            } else {
              return true
            }
          } else {
            return false
          }
        })
    },
    onInputChange(item) {
      // 如果当前输入框被选中则挂答案
      if (item.tenantId == this.currentValue) {
        let v_answer = this.getValue(item.value)
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
      }
      console.log(this.question)
    },
  },
}
